import { useRouteError } from 'react-router-dom';

export function RouteErrorPage() {
    const error = useRouteError();

    if (process.env.NODE_ENV !== 'production') {
        console.error('Route error', error);
    }

    return (
        <main className="min-h-screen bg-[#f5f1e8] px-6 py-12 text-[#111827]">
            <div className="mx-auto flex max-w-xl flex-col items-start gap-4 rounded-3xl border border-[#d6c7ab] bg-white p-6 shadow-sm">
                <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#9f5f12]">ArizaRehberim</p>
                <h1 className="text-2xl font-semibold">Sayfa yuklenirken bir sorun olustu</h1>
                <p className="text-sm leading-6 text-[#4b5563]">
                    Sayfayi bir kez yenileyin. Sorun devam ederse ana sayfadan veya Sanayi Raporu sayfasindan tekrar girin.
                </p>
                <div className="flex flex-wrap gap-3 pt-2">
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        className="rounded-full bg-[#111827] px-4 py-2 text-sm font-medium text-white"
                    >
                        Sayfayi yenile
                    </button>
                    <a
                        href="/"
                        className="rounded-full border border-[#d1d5db] px-4 py-2 text-sm font-medium text-[#111827]"
                    >
                        Ana sayfaya git
                    </a>
                </div>
            </div>
        </main>
    );
}
